export default "__VITE_ASSET__CUaNa5XE__"